import { responseError } from '@/utils/errors';
import { assignProps, mapResults, selectableResult } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findPmnFunction, findPmnFunctions } from './state';

const fetchPmnFunctions = withDraft((draft, action) => {
  const item = findPmnFunctions(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const showPmnFunctions = withDraft((draft, action) => {
  const item = findPmnFunctions(draft, action);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = mapResults([], action, selectableResult);
});

const showPmnFunctionsError = withDraft((draft, action) => {
  const item = findPmnFunctions(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const fetchPmnFunction = withDraft((draft, action) => {
  const item = findPmnFunction(draft, action);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.pmnFunctions[action.category].results.push({
      code: action.code,
      readStatus: states.PENDING,
      readErrors: [],
    });
  }
});

const showPmnFunction = withDraft((draft, action) => {
  const item = findPmnFunction(draft, action);
  assignProps(item, {
    ...action.result,
    readStatus: states.SUCCESS,
    readErrors: [],
  });
});

const showPmnFunctionError = withDraft((draft, action) => {
  const item = findPmnFunction(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

export default {
  [actions.FETCH_PMN_FUNCTION]: fetchPmnFunction,
  [actions.FETCH_PMN_FUNCTIONS]: fetchPmnFunctions,
  [actions.REFRESH_PMN_FUNCTIONS]: fetchPmnFunctions,
  [actions.SHOW_PMN_FUNCTION]: showPmnFunction,
  [actions.SHOW_PMN_FUNCTION_ERROR]: showPmnFunctionError,
  [actions.SHOW_PMN_FUNCTIONS]: showPmnFunctions,
  [actions.SHOW_PMN_FUNCTIONS_ERROR]: showPmnFunctionsError,
};
